export enum SortingDirection {
    Ascending = 'ASC',
    Descending = 'DESC',
}

export type ResponseWrapper<ResponseData> = {
    statusCode: number;
    message: string;
    data: ResponseData;
};

export enum UserRole {
    BranchStudent = 1,
    BranchTeacher = 2,
    BranchEducationDepartment = 3,
    BranchDirector = 4,
    OrganizationDirector = 5,
}

export const RoleGroups = {
    Administration: [
        UserRole.BranchEducationDepartment,
        UserRole.BranchDirector,
        UserRole.OrganizationDirector,
    ],
    Employees: [
        UserRole.BranchTeacher,
        UserRole.BranchEducationDepartment,
        UserRole.BranchDirector,
        UserRole.OrganizationDirector,
    ],
};

export type Role = {
    id: UserRole;
    key: string;
    name: string;
};

export type Filial = {
    id: number;
    name: string;
};

export type UserView = {
    id: number;
    login: string;
    role: Role;
    avatarURL: string | null;
    name: string | null;
    surname: string | null;
    patronymic: string | null;
    filial: Filial;
    canBeEdited: boolean;
    canBeDeactivated: boolean;
    canBeActivated: boolean;
};

type SortingRules = {
    sortField: string;
    sortOrder: string;
    sortingDirection: SortingDirection;
};

type FilterRules<T> = {
    name: string | T;
    surname: string | T;
    login: string | T;
};

type PageMeta = {
    offset: number;
    total: number;
};

type Page = {
    items: UserView[];
    meta: PageMeta;
};

// region Получение всех пользователей постранично
// FIXME: Route switched to POST users/page
export type GetUsersPageRequestPayload = {
    sort: SortingRules | undefined | null;
    filter: FilterRules<null | undefined> | undefined | null;
    offset: number;
    limit: number;
};

export type GetUsersPageResponse = ResponseWrapper<Page>;
// endregion

// region Создание пользователя
// FIXME: Route switched to POST users/
export type CreateUserRequestPayload = {
    login: string;
    password: string;
    roleCode: number;
    name: string;
    surname: string;
    filialId: number;
};

export type CreateUserResponse = ResponseWrapper<null>;
// endregion

// region Обновление информации о пользователе
// FIXME: Route switched to PATCH users/{userId}
export type UpdateUserRequestBody = {
    password: string;
    role: number;
    name: string;
    surname: string;
    filial: number;
};

export type UpdateUserRequestPath = {
    userId: number;
};

export type UpdateUserRequestPayload = {
    path: UpdateUserRequestPath;
    body: UpdateUserRequestBody;
};

export type UpdateUserResponse = ResponseWrapper<null>;
// endregion

// region Получение всех преподавателей
// FIXME: Route switched to GET users/teachers
export type GetTeachersRequestPayload = void;

export type GetTeachersResponse = ResponseWrapper<UserView[]>;
// endregion

// region Получение данных для создания пользователей
// FIXME: Route switched to GET users/data/create
export type GetUserCreationDataRequestPayload = void;

export type GetUserCreationDataResponseData = {
    filials: Filial[];
    roles: Role[];
};

export type GetUserCreationDataResponse = ResponseWrapper<UserView[]>;
// endregion
